export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-50 rounded-2xl border border-background-200/60 p-8 md:p-12">
          <div className="flex-shrink-0 w-full max-w-[320px] aspect-[9/16] rounded-xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20vertical%20scroll%20manga%20reading%20interface%20with%20Japanese%20comic%20panels%20in%20black%20and%20white%20art%20style%2C%20clean%20minimal%20mobile%20app%20UI%20design%2C%20night%20mode%20reading%20with%20warm%20coral%20accent%20colors%2C%20modern%20flat%20design%20with%20subtle%20gradients%2C%20comfortable%20reading%20layout%20on%20phone%20mockup&width=600&height=1067&seq=app-mobile-manga&orientation=portrait"
              alt="哔咔动漫手机端漫画下拉式阅读界面展示"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              随时随地追更
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              哔咔动漫针对手机端深度优化，竖屏下拉式阅读体验如丝般顺滑。无论在通勤路上、午休间隙还是睡前时光，
              打开浏览器即可畅享海量免费漫画，无需下载任何应用，轻量快速，省流量更省空间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold cursor-pointer whitespace-nowrap">
                <i className="ri-smartphone-line"></i>
                手机端体验
              </span>
              <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-background-100 text-foreground-600 text-sm border border-background-200 cursor-pointer whitespace-nowrap">
                <i className="ri-tablet-line"></i>
                平板也适配
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}